import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "../../../common/consts/colors";
export default function HotelCalendarIcon({ color = "black" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8333 15.8333H4.16667V6.66665H15.8333M13.3333 0.833313V2.49998H6.66667V0.833313H5V2.49998H4.16667C3.24167 2.49998 2.5 3.24165 2.5 4.16665V15.8333C2.5 16.2753 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2753 17.5 15.8333V4.16665C17.5 3.72462 17.3244 3.3007 17.0118 2.98814C16.6993 2.67557 16.2754 2.49998 15.8333 2.49998H15V0.833313M14.1667 9.99998H10V14.1666H14.1667V9.99998Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
